export const ROLE_CATALOG = 'catalog',
  ROLE_CATALOG_DOWNLOAD = 'download',
  ROLE_CATALOG_DOWNLOAD_INTERNAL = 'download_internal',
  ROLE_CATALOG_DOWNLOAD_BATCH = 'downloadBatch',
  ROLE_CATALOG_CAN_CROP = 'canCrop';

export const CATALOG_ROLES = [
  ROLE_CATALOG,
  ROLE_CATALOG_DOWNLOAD,
  ROLE_CATALOG_DOWNLOAD_INTERNAL,
  ROLE_CATALOG_DOWNLOAD_BATCH,
  ROLE_CATALOG_CAN_CROP
];
